import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptorsFromDi, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { enableProdMode } from '@angular/core';

import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app.routes';
import { AppconfigService } from './app/shared/appconfig.service';
import { AuthInterceptor } from './app/shared/auth-interceptor';
import { API_URL } from './app/shared/injection-tokens';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        provideRouter(appRoutes),
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
        { provide: Window, useValue: window },
        {
            provide: API_URL,
            useFactory: (svc: AppconfigService) => svc.config.apiUrl,
            deps: [AppconfigService],
        },
    ],
}).catch((err) => console.error(err));
